import {
  SET_CONTACT_SEARCH_CRITERIA,
  CLEAR_CONTACT_SEARCH_CRITERIA,
} from '../actions/actionTypes';

import { pageSize } from '../../pages/ContactsAndVaultingRequests/constants';

const initialState = {
  limit: pageSize,
  offset: 0,
  sort: '-createdOn',
};

const contactSearchCriteriaReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CONTACT_SEARCH_CRITERIA:
      return {
        ...state,
        ...action.payload,
      };
    case CLEAR_CONTACT_SEARCH_CRITERIA:
      return initialState;
    default:
      return state;
  }
};

export default contactSearchCriteriaReducer;
